import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Rosa M.',
    location: 'Miami, FL',
    quote: 'Vendí $340 en mis primeras dos semanas vendiendo tamales y empanadas. No podía creerlo.',
    result: '$340 en 2 semanas',
    initials: 'RM',
    before: 'Cuidaba niños ajenos',
    after: 'Vende su propia comida'
  }, {
    name: 'Carmen L.',
    location: 'Houston, TX',
    quote: 'Tenía miedo de la tecnología pero esto es tan fácil que hasta mi nieta me pregunta cómo lo hago.',
    result: 'Su primera venta en 3 días',
    initials: 'CL',
    before: 'Miedo al celular',
    after: 'Experta en WhatsApp'
  }, {
    name: 'Gloria R.',
    location: 'Los Angeles, CA',
    quote: 'Por fin tengo mi propio dinero. No le pido permiso a nadie para comprar lo que necesito.',
    result: 'Independencia financiera',
    initials: 'GR',
    before: 'Dependía de su esposo',
    after: 'Paga sus propios gustos'
  }];
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer-section');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-20 bg-blush/30 relative overflow-hidden" data-id="element-317">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-318">
        <div className="text-center mb-16" data-id="element-319">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif font-bold text-brown mb-4" data-id="element-320">
            Ellas ya lo lograron.{' '}
            <span className="text-accent underline decoration-accent/30 underline-offset-4" data-id="element-321">
              Tú eres la siguiente.
            </span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-brown-light font-sans max-w-2xl mx-auto" data-id="element-322">
            Mujeres reales, resultados reales, desde su hogar.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-323">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} className="bg-white p-8 rounded-2xl shadow-lg border border-gold/10 relative flex flex-col h-full hover:border-accent/30 transition-colors" data-id="element-324">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-accent/10" data-id="element-325" />

              <div className="flex items-center gap-4 mb-6" data-id="element-326">
                <div className="w-12 h-12 rounded-full bg-accent text-white flex items-center justify-center font-bold text-lg shadow-md" data-id="element-327">
                  {item.initials}
                </div>
                <div data-id="element-328">
                  <h4 className="font-bold text-brown" data-id="element-329">{item.name}</h4>
                  <p className="text-sm text-brown-light" data-id="element-330">{item.location}</p>
                </div>
              </div>

              <div className="flex text-gold mb-4" data-id="element-331">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-current text-accent" data-id="element-332" />)}
              </div>

              <p className="text-brown-light italic mb-6 flex-grow" data-id="element-333">
                "{item.quote}"
              </p>

              {/* Before/After Contrast */}
              <div className="bg-cream/50 rounded-lg p-3 mb-4 text-xs" data-id="element-334">
                <div className="flex items-center justify-between text-brown-light/70 mb-1" data-id="element-335">
                  <span data-id="element-336">Antes: {item.before}</span>
                </div>
                <div className="flex items-center justify-between font-bold text-accent-dark" data-id="element-337">
                  <span data-id="element-338">Ahora: {item.after}</span>
                  <ArrowRight className="w-3 h-3" data-id="element-339" />
                </div>
              </div>

              <div className="mt-auto pt-4 border-t border-cream" data-id="element-340">
                <p className="text-sm text-brown-light" data-id="element-341">Resultado:</p>
                <p className="font-bold text-accent" data-id="element-342">{item.result}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-343">
          <Button variant="accent" onClick={scrollToOffer} className="glow-pink" data-id="element-344">
            Quiero resultados así
            <ArrowRight className="ml-2 w-5 h-5" data-id="element-345" />
          </Button>
        </div>
      </div>
    </section>;
}